export class PleaseWait {
    static show() {
        let url = PleaseWait.imageUrl ?? window.loadingImg?.src;
        let html = 'Please wait...';
        if (url) {
            if (url.endsWith('.svg')) {
                html = `<object type="image/svg+xml" data='${url}'></object>`;
            }
            else {
                html = `<img src='${url}'>`;
            }
        }
        let swalOptions = {
            title: '',
            html: html,
            showConfirmButton: false,
            showCancelButton: false,
            showCloseButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            customClass: {
                container: 'pleaseWait-container',
            },
            showClass: {
                popup: '',
                icon: ''
            },
            hideClass: {
                popup: '',
            },
        };
        Swal.fire(swalOptions);
    }
    static hide(callback) {
        Swal.close();
        if (callback != null) {
            callback();
        }
    }
}
window.PleaseWait = PleaseWait;
